var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('v-client-table',{ref:"dataTable",attrs:{"data":_vm.buildings,"columns":_vm.columns,"options":_vm.options,"theme":_vm.theme,"id":"dataTable"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }